interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
}

export function LoadingSpinner({
  className,
  size = 'md',
  fullScreen = false,
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'size-3',
    md: 'size-4',
    lg: 'size-6',
  };

  const spinner = (
    <output
      aria-live="polite"
      aria-label="loading"
      className={`inline-block rounded-full border-2 border-current animate-spin text-primary border-t-transparent ${sizeClasses[size]} ${className || ''}`}
    />
  );

  if (fullScreen) {
    return <div className="flex justify-center items-center w-screen h-screen">{spinner}</div>;
  }

  return spinner;
}
